module.exports = __webpack_public_path__ + "static/media/AttackerNoBackground.746f169c.png";